<template>
	<div>
		<div class="ng-header">
				<div class="w1200 top-header">
					<div class="ng-site-logo">
						<a :href="CurrentEnvPrefix.main+Common.getSourec().sitehost">
<!--              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="180.00143432617188" height="40.2236328125" viewBox="0 0 180.00143432617188 40.2236328125" fill="none" class="injected-svg" data-src="/svg/cs_logo.svg"><g opacity="1" transform="translate(0 0)  rotate(0)"><path id="路径 1-1" fill-rule="evenodd" style="fill:var(&#45;&#45;main-logo-color)" opacity="1" d="M33.52,0c3.7,0 6.7,3 6.7,6.7v26.82c0,3.7 -3,6.7 -6.7,6.7h-26.82c-3.7,0 -6.7,-3 -6.7,-6.7v-26.82c0,-3.7 3,-6.7 6.7,-6.7zM5.7,27.72h9.76v-3.94h-4.97l4.97,-4.02v-5.02h-4.97l4.97,-4.02v-5.02l-9.76,7.88v5.03v0.07h4.88l-4.88,3.94v5.03zM34.52,23.94c0,-4.06 -3.13,-7.54 -7.19,-7.74c-1.5,-0.08 -2.9,0.29 -4.11,0.98v-4.72h11.3v-3.81h-6.18v-2.95h-4.61v2.95h-6.63v3.81h1.83v14.66c0,1.7 -1.39,3.09 -3.09,3.09h-10.14v4.31h10.4c3.94,0 7.13,-3.19 7.13,-7.12v-4.27c0.31,-1.85 1.95,-3.24 3.9,-3.15c2.04,0.09 3.61,1.86 3.61,3.9v6.86l-5.05,3.78h8.83z"></path><g opacity="1" transform="translate(49.84912109375 0)  rotate(0)"><path id="路径 2-2" fill-rule="evenodd" style="fill:#141414" opacity="1" d="M0 40.2235L15.08 40.2235L15.08 34.3535L0 34.3535L0 40.2235Z"></path><path id="路径 3-3" fill-rule="evenodd" style="fill:#141414" opacity="1" d="M13.13 0L6.7 0L0 10.05L0 15.92L6.14 15.92L0 25.14L0 31L15.08 31L15.08 25.14L6.43 25.14L16.48 10.05L6.43 10.05L13.13 0Z"></path><path id="路径 4-4" fill-rule="evenodd" style="fill:#141414" opacity="1" d="M80.1729 29.92C80.9029 28.11 81.2629 26.16 81.2629 24.06L81.2429 18.2C81.1729 15.49 78.9529 13.31 76.2229 13.31L68.5229 13.31L68.5229 9.28L85.4629 9.28L85.4629 4.25L68.5229 4.25L68.5229 0L62.1929 0L62.1929 4.25L45.2429 4.25L45.2429 9.28L62.1829 9.28L62.1829 13.31L49.6629 13.31L49.6629 18.34L74.9629 18.34L74.9629 18.34L74.9629 24.06C74.9629 25.3 74.7929 26.45 74.4629 27.48C74.1229 28.51 73.5829 29.44 72.8429 30.26C72.0929 31.08 71.1229 31.79 69.9229 32.39C68.7129 32.98 67.2529 33.46 65.5129 33.82C63.8129 33.46 62.3629 32.98 61.1729 32.39C59.9929 31.79 59.0229 31.09 58.2729 30.29C57.5329 29.48 56.9929 28.56 56.6529 27.53C56.3229 26.49 56.1529 25.33 56.1529 24.06L56.1529 22.5L49.8529 22.5L49.8529 24.06C49.8529 26.19 50.2129 28.16 50.9229 29.97C51.6429 31.78 52.8229 33.38 54.4629 34.78L45.2429 34.78L45.2429 40.22L54.1029 40.22C56.2929 40.22 58.3229 40.14 60.1929 39.99C62.0629 39.84 63.8029 39.61 65.4229 39.3C67.0329 39.61 68.7629 39.84 70.6229 39.99C72.4829 40.14 74.5029 40.22 76.6929 40.22L85.4629 40.22L85.4629 34.78L76.4729 34.79C78.2029 33.36 79.4429 31.74 80.1729 29.92Z"></path><path id="路径 5-5" fill-rule="evenodd" style="fill:#141414" opacity="1" d="M113.212 0L106.872 0L106.872 4.25L89.9323 4.25L89.9323 12.01L94.9623 12.01L94.9623 9.28L125.122 9.28L125.122 12.01L130.152 12.01L130.152 4.25L113.212 4.25L113.212 0Z"></path><path id="路径 6-6" fill-rule="evenodd" style="fill:#141414" opacity="1" d="M106.872 18.7132L106.872 23.1832L89.9323 23.1832L89.9323 28.5832L106.872 28.5832L106.872 34.5432L89.9323 34.5432L89.9323 40.2232L130.152 40.2232L130.152 30.9132L123.882 30.9132L123.882 34.5432L113.212 34.5432L113.212 28.5832L130.152 28.5832L130.152 23.1832L113.212 23.1832L113.212 18.7132L130.152 18.7132L130.152 13.3132L89.9323 13.3132L89.9323 18.7132L106.872 18.7132Z"></path><path id="路径 7-7" fill-rule="evenodd" style="fill:#141414" opacity="1" d="M25.7177 0L25.7177 4.25L17.5577 4.25L17.5577 9.28L20.1077 9.28L20.1077 31.8C20.1077 33.21 18.9677 34.35 17.5577 34.35L17.5577 40.22L20.6277 40.22C23.1177 40.22 25.1377 38.2 25.1377 35.71L25.1377 18.62L35.1877 18.62L35.1877 31.58C35.1877 33.11 33.9477 34.35 32.4177 34.35L30.1677 34.35L30.1677 40.22L35.7077 40.22C38.1977 40.22 40.2177 38.2 40.2177 35.71L40.2177 13.59L25.1377 13.59L25.1377 9.28L40.2177 9.28L40.2177 4.25L32.0577 4.25L32.0577 0L25.7177 0Z"></path></g></g></svg>-->

              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="180.00143432617188" height="40.2236328125" viewBox="0 0 180.00143432617188 40.2236328125" fill="none" class="injected-svg" data-src="/svg/cs_logo.svg">
                <g opacity="1" transform="translate(0 0)  rotate(0)">
                  <path id="路径 1-1" fill-rule="evenodd" fill="url(#home_svg_style)" opacity="1" d="M33.52,0c3.7,0 6.7,3 6.7,6.7v26.82c0,3.7 -3,6.7 -6.7,6.7h-26.82c-3.7,0 -6.7,-3 -6.7,-6.7v-26.82c0,-3.7 3,-6.7 6.7,-6.7zM5.7,27.72h9.76v-3.94h-4.97l4.97,-4.02v-5.02h-4.97l4.97,-4.02v-5.02l-9.76,7.88v5.03v0.07h4.88l-4.88,3.94v5.03zM34.52,23.94c0,-4.06 -3.13,-7.54 -7.19,-7.74c-1.5,-0.08 -2.9,0.29 -4.11,0.98v-4.72h11.3v-3.81h-6.18v-2.95h-4.61v2.95h-6.63v3.81h1.83v14.66c0,1.7 -1.39,3.09 -3.09,3.09h-10.14v4.31h10.4c3.94,0 7.13,-3.19 7.13,-7.12v-4.27c0.31,-1.85 1.95,-3.24 3.9,-3.15c2.04,0.09 3.61,1.86 3.61,3.9v6.86l-5.05,3.78h8.83z"></path>
                  <g opacity="1" transform="translate(49.84912109375 0)  rotate(0)">
                    <path id="路径 2-2" fill-rule="evenodd" style="fill:#141414" opacity="1" d="M0 40.2235L15.08 40.2235L15.08 34.3535L0 34.3535L0 40.2235Z"></path>
                    <path id="路径 3-3" fill-rule="evenodd" style="fill:#141414" opacity="1" d="M13.13 0L6.7 0L0 10.05L0 15.92L6.14 15.92L0 25.14L0 31L15.08 31L15.08 25.14L6.43 25.14L16.48 10.05L6.43 10.05L13.13 0Z"></path>
                    <path id="路径 4-4" fill-rule="evenodd" style="fill:#141414" opacity="1" d="M80.1729 29.92C80.9029 28.11 81.2629 26.16 81.2629 24.06L81.2429 18.2C81.1729 15.49 78.9529 13.31 76.2229 13.31L68.5229 13.31L68.5229 9.28L85.4629 9.28L85.4629 4.25L68.5229 4.25L68.5229 0L62.1929 0L62.1929 4.25L45.2429 4.25L45.2429 9.28L62.1829 9.28L62.1829 13.31L49.6629 13.31L49.6629 18.34L74.9629 18.34L74.9629 18.34L74.9629 24.06C74.9629 25.3 74.7929 26.45 74.4629 27.48C74.1229 28.51 73.5829 29.44 72.8429 30.26C72.0929 31.08 71.1229 31.79 69.9229 32.39C68.7129 32.98 67.2529 33.46 65.5129 33.82C63.8129 33.46 62.3629 32.98 61.1729 32.39C59.9929 31.79 59.0229 31.09 58.2729 30.29C57.5329 29.48 56.9929 28.56 56.6529 27.53C56.3229 26.49 56.1529 25.33 56.1529 24.06L56.1529 22.5L49.8529 22.5L49.8529 24.06C49.8529 26.19 50.2129 28.16 50.9229 29.97C51.6429 31.78 52.8229 33.38 54.4629 34.78L45.2429 34.78L45.2429 40.22L54.1029 40.22C56.2929 40.22 58.3229 40.14 60.1929 39.99C62.0629 39.84 63.8029 39.61 65.4229 39.3C67.0329 39.61 68.7629 39.84 70.6229 39.99C72.4829 40.14 74.5029 40.22 76.6929 40.22L85.4629 40.22L85.4629 34.78L76.4729 34.79C78.2029 33.36 79.4429 31.74 80.1729 29.92Z"></path>
                    <path id="路径 5-5" fill-rule="evenodd" style="fill:#141414" opacity="1" d="M113.212 0L106.872 0L106.872 4.25L89.9323 4.25L89.9323 12.01L94.9623 12.01L94.9623 9.28L125.122 9.28L125.122 12.01L130.152 12.01L130.152 4.25L113.212 4.25L113.212 0Z"></path>
                    <path id="路径 6-6" fill-rule="evenodd" style="fill:#141414" opacity="1" d="M106.872 18.7132L106.872 23.1832L89.9323 23.1832L89.9323 28.5832L106.872 28.5832L106.872 34.5432L89.9323 34.5432L89.9323 40.2232L130.152 40.2232L130.152 30.9132L123.882 30.9132L123.882 34.5432L113.212 34.5432L113.212 28.5832L130.152 28.5832L130.152 23.1832L113.212 23.1832L113.212 18.7132L130.152 18.7132L130.152 13.3132L89.9323 13.3132L89.9323 18.7132L106.872 18.7132Z"></path>
                    <path id="路径 7-7" fill-rule="evenodd" style="fill:#141414" opacity="1" d="M25.7177 0L25.7177 4.25L17.5577 4.25L17.5577 9.28L20.1077 9.28L20.1077 31.8C20.1077 33.21 18.9677 34.35 17.5577 34.35L17.5577 40.22L20.6277 40.22C23.1177 40.22 25.1377 38.2 25.1377 35.71L25.1377 18.62L35.1877 18.62L35.1877 31.58C35.1877 33.11 33.9477 34.35 32.4177 34.35L30.1677 34.35L30.1677 40.22L35.7077 40.22C38.1977 40.22 40.2177 38.2 40.2177 35.71L40.2177 13.59L25.1377 13.59L25.1377 9.28L40.2177 9.28L40.2177 4.25L32.0577 4.25L32.0577 0L25.7177 0Z"></path>
                  </g>
                </g>
                <defs>
                  <linearGradient id="home_svg_style" x1="74.04955117674645%" y1="23.408234119415283%" x2="21.058357292630035%" y2="99.9998688697815%" gradientUnits="objectBoundingBox">
                    <stop offset="0" stop-color="var(--home-svg-color-0)" stop-opacity="1" />
                    <stop offset="1" stop-color="var(--home-svg-color-1)" stop-opacity="1" />
                  </linearGradient>
                </defs>
              </svg>

<!--              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="40.21875" height="40.21856689453125" viewBox="0 0 40.21875 40.21856689453125" fill="none">-->
<!--                <g opacity="1"  transform="translate(0 0)  rotate(0)">-->
<!--                  <path id="矩形 1" fill-rule="evenodd" style="fill:#FFFFFF" opacity="1" d="M4 38L37 38L37 2L4 2L4 38Z"></path>-->
<!--                  <path id="路径 1" fill-rule="evenodd" fill="url(#linear_0)" opacity="1" d="M33.5157 0L6.70286 0C3.00083 0 0 3.00083 0 6.70286L0 33.5157C0 37.2177 3.00083 40.2186 6.70286 40.2186L33.5157 40.2186C37.2177 40.2186 40.2186 37.2177 40.2186 33.5157L40.2186 6.70286C40.2186 3.00083 37.2177 0 33.5157 0ZM5.69798 27.6465L5.69798 22.6235L10.5802 18.6813L5.69798 18.6813L5.69798 18.6068L5.69798 13.5824L15.4624 5.6966L15.4624 10.7196L10.4877 14.7364L15.4624 14.7364L15.4624 19.7594L10.4877 23.7761L15.4624 23.7761L15.4624 27.7183L5.69798 27.7183L5.69798 27.6465ZM34.5219 34.5219L25.6934 34.5219L30.7385 30.7385L30.7385 23.8824C30.7385 21.8381 29.1718 20.0672 27.1289 19.9761C25.1758 19.8877 23.5359 21.2832 23.2267 23.1287L23.2267 27.3953C23.2267 31.3306 20.0368 34.5219 16.1001 34.5219L5.6966 34.5219L5.6966 30.207L15.8351 30.207C17.5426 30.207 18.927 28.8226 18.927 27.1151L18.927 12.4588L17.0995 12.4588L17.0995 8.65464L23.7264 8.65464L23.7264 5.69798L28.3395 5.69798L28.3395 8.65464L34.5192 8.65464L34.5192 12.4588L23.224 12.4588L23.224 17.1754C24.4262 16.4935 25.83 16.125 27.3277 16.1981C31.3886 16.3969 34.5192 19.8753 34.5192 23.9417L34.5219 34.5219Z"></path>-->
<!--                </g>-->
<!--                <defs>-->
<!--                  <linearGradient id="linear_0" x1="74.04955117674645%" y1="23.408234119415283%" x2="21.058357292630035%" y2="99.9998688697815%" gradientUnits="objectBoundingBox">-->
<!--                    <stop offset="0" stop-color="#4098EE" stop-opacity="1" />-->
<!--                    <stop offset="1" stop-color="#2357E8" stop-opacity="1" />-->
<!--                  </linearGradient>-->
<!--                </defs>-->
<!--              </svg>-->
            </a>
					</div>
					<div class="ng-head-search-bar" id="search" v-on:mouseleave="hiddensearch()">
						<ul class="ng-tab">
							<li :class="{'current':tabnum==index}" v-for="tab,index in tab" @click="tabsearchClick(index)">{{tab}}</li>
						</ul>
                        <div style="width:100%;display:inline-block;">
    						<div class="search-form main-color-border-2">
    							<input type="hidden" name="" value="search">
    							<input type="text" name="" placeholder="关键词、货号" class="input-text" @click="searchClick()" ref="inputname" v-if="tabnum==0">
                                <input type="text" name="" placeholder="请输入厂家关键字" class="input-text" @click="searchClick()" ref="inputname" v-if="tabnum==1">
                                <!-- <input type="text" name="" placeholder="请输入货号" class="input-text" @click="searchClick()" ref="inputname" v-if="tabnum==2"> -->
                                <input type="text" name="" placeholder="请输入SKU编码" class="input-text" @click="searchClick()" ref="inputname" v-if="tabnum==2">
                                <label>
                                    <input type="submit" name="" value="" class="brand-color-bg input-submit" @click="searchsureClick()">
                                    <img src="../../assets/image/search1.png" style="position: absolute;right: 23px;top: 3px;width: 30px;cursor: pointer;">
                                </label>

    						</div>
    						<div class="main-color main-color-border-2" style="position: relative;cursor:pointer;margin-left:7px;overflow:hidden;width:106px;height:40px;font-size:12px;background-color: #fff;border-radius: 8px;float:left;line-height:36px;text-align:center;">
    					        <label>
    					          <span><label><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1em" height="0.8215em" viewBox="0 0 20 16.429931640625" fill="currentColor" style="font-size: 15px;vertical-align: text-top;"><path opacity="1" d="M2.14,2.14h2.15l0.5,-1.5c0.14,-0.35 0.5,-0.64 0.92,-0.64h8.58c0.35,0 0.78,0.29 0.92,0.64l0.5,1.5h2.15c1.21,0 2.14,0.93 2.14,2.15v10c0,1.21 -0.93,2.14 -2.14,2.14h-15.72c-1.14,0 -2.14,-0.93 -2.14,-2.14v-10c0,-1.22 0.93,-2.15 2.14,-2.15zM17.8618,3.21129h-2.93l-0.22,-0.71l-0.5,-1.43h-8.43002l-0.5,1.43l-0.21,0.71h-2.93c-0.57,0 -1.07,0.5 -1.07,1.07v10.00001c0,0.58 0.5,1.08 1.07,1.08h15.72002c0.57,0 1.07,-0.5 1.07,-1.08v-10.00001c0,-0.57 -0.5,-1.07 -1.07,-1.07zM5,8.57227c0,-2.79 2.21,-5 5,-5c2.79,0 5,2.21 5,5c0,2.79003 -2.21,5.00003 -5,5.00003c-2.79,0 -5,-2.21 -5,-5.00003zM13.9318,8.57355c0,-2.14 -1.79,-3.93 -3.93,-3.93c-2.14002,0 -3.93002,1.79 -3.93002,3.93c0,2.14005 1.79,3.93005 3.93002,3.93005c2.14,0 3.93,-1.79 3.93,-3.93005z" ></path></svg> 以图搜款<input type="file" id="file" name="card_z" accept="image/png,image/jpeg,image/gif" class="input-file" hidefocus="true" @change="uploadChange" ref="upload"/></label></span>
    					          <input type="file" name="file_search" hidefocus="true" size="1" class="input-file" style="width:0px;height: 26px;opacity: 0;cursor: pointer;border: 0;">
    					        </label>
    					    </div>
                        </div>
					    <div class="ng-search-tip" style="border-radius: 8px" v-show="hotshow">
					    	<div class="ng-search-history">
					    		<div class="ng-h-title">历史记录<a href="javascript:;" @click="delword()">清除</a></div>
					    		<ul class="ng-h-list" style="height:82px;overflow:hidden;">
					    			<li v-for="list in searchlist" v-if="tabnum==0"><a href="javascript:;">{{list}}</a></li>
					    			<li v-for="list in storesearchlist" v-if="tabnum==1"><a href="javascript:;">{{list}}</a></li>
                                    <li v-for="list in skusearchlist" v-if="tabnum==2"><a href="javascript:;">{{list}}</a></li>
					    		</ul>
                                <div class="ng-h-title">好货推荐</div>
                                <div class="ng-h-goods">
                                    <a v-if="list&&list.ads" :href="list.ads[0].url"  :title="list.adv_title">
                                        <img :src="list.ads[0].pic">
                                    </a>
                                </div>
					    	</div>
					    	<div class="ng-search-hot" v-if="brandlist.length<=6">
					    		<div class="ng-h-title">热门推荐...</div>
					    		<!-- <ul class="ng-hot-list">
					    			<li v-for="keyword in goodskeyword" @click="kwsearchClick(keyword)"><a href="javascript:;">{{keyword}}</a></li>
					    		</ul> -->
                                <ul class="ng-hot-brand">
                                    <li v-for="list in brandlist">
                                        <a :href="list.ads[0].url"><img :src="list.ads[0].pic"></a>
                                    </li>
                                </ul>
					    	</div>
                            <div class="ng-search-hot1" v-if="brandlist.length>6">
                                <div class="ng-h-title">热门推荐...</div>
                                <!-- <ul class="ng-hot-list">
                                    <li v-for="keyword in goodskeyword" @click="kwsearchClick(keyword)"><a href="javascript:;">{{keyword}}</a></li>
                                </ul> -->
                                <ul class="ng-hot-brand1">
                                    <li v-for="list in brandlist">
                                        <a :href="list.ads[0].url"><img :src="list.ads[0].pic"></a>
                                    </li>
                                </ul>
                            </div>
					    </div>
					    <div class="ng-keyword">
					    	<ul>
					    		<li v-for="keyword in goodskeyword" @click="kwsearchClick(keyword)"><a href="javascript:;">{{keyword}}</a></li>
					    	</ul>
					    </div>
					</div>
					<!-- <div style="float:right;text-align:right;width:260px;height:90px;overflow:hidden;padding-top:10px">
				      	<a target="_blank" :href="CurrentEnvPrefix.main+'/shop/index.php?act=index&amp;op=download'"><img style="width: 200px" src="http://www.fangzhibao.com/shop/templates/default/images/app_code.png"></a>
				    </div> -->

				</div>
			</div>
	</div>
</template>
<style scoped>
	.input-file{display: none}
    .ng-h-goods{width: 100%;padding:0 8px;}
    .ng-h-goods img{width: 100%;height: 200px;border-radius: 10px}
    .ng-hot-brand{width: 415px;}
    .ng-hot-brand li{width: 117px;float: left;height: 142px;margin-right: 15px;margin-top:16px;}
    .ng-hot-brand,.ng-hot-brand1{padding: 0 10px;display: inline-block;}
    .ng-hot-brand1 li{width: 117px;float: left;height: 142px;margin-right: 5px;margin-top:16px;}
    .ng-hot-brand li:nth-child(3n){margin-right: 0;}
    .ng-hot-brand li img,.ng-hot-brand1 li img{width: 100%;height: 142px;border-radius: 10px}
    .ng-hot-brand1 li:nth-child(4n){margin-right: 0;}
</style>
<script>
import {CurrentEnvPrefix} from 'config/urlprefix.js'
export default {
  	data () {
    	return {
				CurrentEnvPrefix,
    		hotshow:false,
    		hotkeyword:[],
    		goodskeyword:[],
    		tab:['商品','厂家','SKU编码'],
    		tabnum:0,
    		goodssearch:true,
    		searchlist:[],
    		storesearchlist:[],
            list:[],
            brandlist:[],
            site_logo:{},
            skusearchlist:[],
    	}
  	},
    methods: {
    	tabsearchClick(index){
    		this.tabnum=index;
            if(index==1){
                this.goodssearch = false;
            }else{
                this.goodssearch = true;
            }
    		this.getHotKeyWord();
    	},
    	searchClick(){
    		this.hotshow=true;
    	},
    	hiddensearch(){
    		this.hotshow=false;
    	},
    	getHotKeyWord(){
    		this.$Api.get({api:'/fragment/hotkeywords'}).then(response => {
	    		this.hotkeyword=response.data.datas;
	    		if(this.goodssearch){
	    			this.goodskeyword=this.hotkeyword.goods;

	    		}else{
	    			this.goodskeyword=this.hotkeyword.store;
	    		}
	    	});
    	},
    	uploadChange(e){
            var files = e.target.files[0];
            var _formData = new FormData();
            const _this = this;
            _formData.append('name', 'card_z');
            _formData.append('key', this.$Api.getMKey());
            _formData.append('card_z', files);
            this.$Api.uploadResource({
                    api: '/mobile/index.php?act=goods&op=search',
                    formdata: _formData
                }, function (callbackProgress){
                    _this.$nextTick(() =>{
                        _this.progress=callbackProgress;
                        // console.log(_this.progress)
                    })
                }, function (callBackResult){
                    //处理数据，跳到goodslist页面
                    var param = callBackResult.data || [];
                    var result = param.length > 0 ? param[0]:null;
					const images = param.length > 0 ? param[1]:null;
                    if(result||images){
                        var href= CurrentEnvPrefix.search+_this.Common.getSourec().sitehost1+"/search/index/searchbyimage?goods_id=&images="+images;
						window.location.href = href;
                    }
            }).then(response => {
            });
        },
        searchsureClick(){
            var keyword = this.$refs.inputname.value;
            this.kwsearchClick(keyword);
        },
        kwsearchClick(keyword){
            console.log(this.tabnum)
        	if(this.goodssearch){
                if(this.tabnum == 1||this.tabnum == 0){
                    this.Common.setGoodsword(keyword);
                    window.location.href = CurrentEnvPrefix.search+this.Common.getSourec().sitehost1+"/?1=1&keyword="+keyword;
                }else if(this.tabnum == 2){
                    this.Common.setSkuword(keyword);
                    window.location.href = CurrentEnvPrefix.productionDetailUrl+"/goods/index?goods_id="+keyword;
                }
                // }else if(this.tabnum == 2){
                //     this.Common.setGoodsword(keyword);
                //     window.location.href = CurrentEnvPrefix.search+this.Common.getSourec().sitehost1+"/?1=1&goods_serial="+keyword;
                // }

        	}else{
        		this.Common.setStoreword(keyword);
        		window.location.href = CurrentEnvPrefix.search+this.Common.getSourec().sitehost1+"/search/store&keyword="+keyword;
        	}

        },
        delword(){
        	if(this.tabnum==0){
        		this.$dialog.confirm({
	                mes: '确定要删除全部历史搜索吗？',
	                opts: () => {
	                    this.Common.delGoodsword();
	                    this.searchlist = this.Common.getGoodsword();
	                }
	            });
        	}else if(this.tabnum==1){
        		this.$dialog.confirm({
	                mes: '确定要删除全部历史搜索吗？',
	                opts: () => {
	                    this.Common.delStoresword();
	                    this.storesearchlist = this.Common.getStoreword();
	                }
	            });
        	}else if(this.tabnum==2){
                this.$dialog.confirm({
                    mes: '确定要删除全部历史搜索吗？',
                    opts: () => {
                        this.Common.delSkusword();
                        this.storesearchlist = this.Common.getSkuword();
                    }
                });
            }

        },
        getList(){
            this.$Api.get({api:'/ad/list',param:{ad_type:'commonsearch.history.ads'}}).then(response => {
                var datas = response.data.datas;
                var lastindex = this.$cookie.get('hhtj')||'';
                if(lastindex==''){
                    lastindex=0
                    this.$cookie.set('hhtj',lastindex,'1D');
                }else{
                    lastindex = lastindex==0 ? 1 : 0 ;
                }
                this.$cookie.set('hhtj',lastindex,'1D');
                this.list = datas[lastindex];
            });
        },
        getBrandList(){
            this.$Api.get({api:'/ad/list',param:{ad_type:'commonsearch.brandlist'}}).then(response => {
                this.brandlist = response.data.datas;
            });
        },
        getLogo(){
            var _this = this;
            setTimeout(function(){
                var site = _this.Common.getSourec().site;
                _this.site_logo = site ? site.site_logo :'';
            },500);
        },

    },
    destroyed () {
		window.removeEventListener('scroll', this.handleScroll);
	},
    mounted(){
    	this.getHotKeyWord();
    	window.addEventListener('scroll', this.handleScroll);
    	this.searchlist = this.Common.getGoodsword() || [];
        for(var i = 0; i < this.searchlist.length; i++){
            for(var m = 0; m < this.searchlist.length; m++){
                if(i != m && this.searchlist[i] == this.searchlist[m]){
                    this.searchlist.splice(m,1);
                }
            }
        }
        this.storesearchlist = this.Common.getStoreword() || [];
        this.skusearchlist = this.Common.getSkuword() || [];
        for(var i = 0; i < this.storesearchlist.length; i++){
            for(var m = 0; m < this.storesearchlist.length; m++){
                if(i != m && this.storesearchlist[i] == this.storesearchlist[m]){
                    this.storesearchlist.splice(m,1);
                }
            }
        }
        this.getList();
        this.getBrandList();
        this.getLogo();
    }
}
</script>



// WEBPACK FOOTER //
// src/components/public/header.vue